export default __webpack_public_path__ + "static/assets/0d944ede441d10e4fa862a6067ae23ec.svg";